function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import { Select } from "../../../../../Components/Forms";
import { t, Translate } from "../../../../../../I18N";
import { thesauriAtom } from "../../../../../atoms";

import { orderBy } from 'lodash';






export const ThesaurusField = ({ control, disabled }) => {
  const thesauri = useAtomValue(thesauriAtom);

  const thesaurusOptions = useMemo(() => {
    const filteredThesauri = thesauri.filter(
      (thesaurus) => thesaurus.type !== 'template'
    );

    const options = orderBy(
      filteredThesauri.map((thesaurus) => ({
        value: thesaurus._id,
        label: t(thesaurus._id, thesaurus.name, null, false)
      })),
      'label'
    );

    options.unshift({
      value: '',
      label: t('System', 'Select...', null, false)
    });

    return options;
  }, [thesauri]);

  return (/*#__PURE__*/
    _jsx(Controller, {
      name: "content",
      control: control,
      rules: { required: true },
      render: ({ field }) => /*#__PURE__*/
      React.createElement(Select, _extends({
        id: "property-thesaurus",
        label: /*#__PURE__*/
        _jsx("div", { className: "flex items-center gap-1" }, void 0, /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Thesaurus"), /*#__PURE__*/
        _jsx("span", {}, void 0, "*")
        ),

        options: thesaurusOptions,
        disabled: disabled },
      field)
      ) }

    ));

};